import { setList } from './municipalitySlice';
import api, { normalize } from 'api';

export {
  setList
}

export const getList = (prefix, params) => async dispatch => {
  try{
    const response = await api.get('site/municipalities', { params  })
    const municipalities = normalize(response).municipalities || {}
    dispatch(setList({ prefix, municipalities }))
  }catch(e){
    console.log(e)
  }
  
} 


export const view = (prefix, municipality_id ,params) => async dispatch => {
  try{
    const response = await api.get(`site/municipalities/${municipality_id}`, { params })
    const municipalities = normalize(response).municipalities || {}
    dispatch(setList({ prefix, municipalities }))
  }catch(e){
    console.log(e)
  }
} 
